// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1UFOU","container":"Modal_container__1YD0g","close":"Modal_close__4N-dx","icon":"Modal_icon__sRuZ-","content":"Modal_content__396Js"};